import axiosInstance from '../../../lib/axios';
import type {
  NotificationDetail,
  NotificationListParams,
  NotificationListResponse,
  NotificationPreferences,
  UnreadCountResponse,
  UpdateNotificationPreferencesInput,
} from '../types';

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const response = await axiosInstance.get('/v1/notifications/unread-count');
  return response.data.data;
}

export async function listNotifications(
  params: NotificationListParams = {}
): Promise<NotificationListResponse> {
  const response = await axiosInstance.get('/v1/notifications', { params });
  return response.data.data;
}

export async function getNotification(publicId: string): Promise<NotificationDetail> {
  const response = await axiosInstance.get(`/v1/notifications/${publicId}`, {
    skipErrorToast: true,
  });
  return response.data.data;
}

export async function markNotificationRead(publicId: string): Promise<{ readAt: string }> {
  const response = await axiosInstance.post(`/v1/notifications/${publicId}/read`);
  return response.data.data;
}

export async function markNotificationUnread(publicId: string): Promise<{ readAt: null }> {
  const response = await axiosInstance.post(`/v1/notifications/${publicId}/unread`);
  return response.data.data;
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  const response = await axiosInstance.post('/v1/notifications/read-all');
  return response.data.data;
}

export async function archiveNotification(publicId: string): Promise<{ archived: true }> {
  const response = await axiosInstance.delete(`/v1/notifications/${publicId}`);
  return response.data.data;
}

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
  const response = await axiosInstance.get('/v1/notifications/preferences', {
    skipErrorToast: true,
  });
  return response.data.data;
}

export async function updateNotificationPreferences(
  input: UpdateNotificationPreferencesInput
): Promise<NotificationPreferences> {
  const response = await axiosInstance.patch('/v1/notifications/preferences', input, {
    skipErrorToast: true,
  });
  return response.data.data;
}
